import { run } from "./run-app";

// This file is the entry point for the web worker, both __APP_DATA and __INITIAL_STATE are injected
// into the global scope of the web worker by concatenating the serialized data into the worker script.
// You can find __APP_DATA in code-handler.ts -> serializeAppData()
// You can find __INITIAL_STATE__ in code-handler.ts -> serializeInitialState()
// The concatenation of all parts and initialization of the worker is done in attach.ts -> register()
run(self.__APP_DATA__, self.__INITIAL_STATE__);
